import type { estypes } from '@elastic/elasticsearch'

export const superGenericPropertyMapping = {
  prop0: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop1: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop2: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop3: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop4: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop5: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop6: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop7: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop8: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop9: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop10: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop11: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop12: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop13: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop14: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop15: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop16: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop17: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop18: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop19: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop20: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop21: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop22: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop23: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop24: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop25: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop26: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop27: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop28: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop29: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop30: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop31: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop32: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop33: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop34: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop35: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop36: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop37: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop38: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop39: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop40: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop41: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop42: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop43: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop44: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop45: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop46: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop47: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop48: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop49: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop50: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop51: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop52: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop53: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop54: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop55: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop56: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop57: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop58: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop59: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop60: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop61: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop62: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop63: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop64: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop65: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop66: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop67: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop68: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop69: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop70: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop71: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop72: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop73: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop74: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop75: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop76: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop77: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop78: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop79: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop80: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop81: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop82: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop83: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop84: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop85: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop86: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop87: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop88: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop89: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop90: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop91: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop92: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop93: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop94: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop95: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop96: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop97: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop98: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop99: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
  prop100: {
    properties: {
      keyword: {
        type: 'keyword',
        index: false,
      },
      date: {
        type: 'date',
        index: false,
      },
      number: {
        type: 'float',
        index: false,
      },
      boolean: {
        type: 'boolean',
        index: false,
      },
    },
  },
} satisfies Record<string, estypes.MappingProperty>
